const Reset = () => <>Reset</>;

export default Reset;
